import { Avatar, Grid, IconButton, ListItem, ListItemAvatar, ListItemText, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import InquiryService from "../../services/inquiryService";
import PendingIcon from "@mui/icons-material/Pending";

const ChatItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: "#f0f8ff",
  borderRadius: 10,
  padding: 2,
  boxShadow: "none",
  padding: "1px 0 1px 20px",
  width: "75%",
  marginBottom: "10px",
}));
const ChatLeft = ({ feed, user }) => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const acceptRequest = async () => {
    setIsLoading(true);
    await InquiryService.acceptInquiry(feed?.Inquiry?.id);
    setIsAccepted(true);
    setIsLoading(false);
  };
  return (
    <Grid container direction="row" alignItems="space-between">
      {(!feed?.isAutoGenerated ||
        (feed?.Inquiry?.employee !== null && user.id === feed?.Inquiry?.employee) ||
        (feed?.Inquiry?.department !== null && (feed?.Inquiry?.department === user?.department || 
          feed?.Inquiry?.department === 1 )) || (feed?.Inquiry?.department=== '' || null && feed?.Inquiry?.employee==='')
          || (feed?.Inquiry?.department=== null && feed?.Inquiry?.employee===null) ) && (
        <>
          <ChatItem
            alignItems="flex-start"
            sx={{
              backgroundColor: !feed?.isAutoGenerated ? "#f0f8ff" : !feed?.Inquiry?.isAccepted ? "orange" : "green",
              color: feed?.isAutoGenerated ? "white" : "black",
            }}
          >
            <ListItemAvatar>
              <Avatar
                alt={feed?.isAutoGenerated ? "System generated" : feed?.Employee?.name}
                src={
                  feed?.isAutoGenerated
                    ? "/images/auto-gen.png"
                    : feed?.Employee?.imagePath || "/static/images/avatar/1.jpg"
                }
              />
            </ListItemAvatar>

            <ListItemText
             primary={
              <React.Fragment>
                <Typography
                  sx={{ color: feed?.isAutoGenerated ? "white" : "black", display: "inline" }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                   {feed?.isAutoGenerated && (`${feed?.Inquiry?.name} ` || "")}
                   {feed?.isAutoGenerated && ( feed?.Inquiry?.visitType === 1 ? " is in lobby " :" has called ")}
                   {feed?.isAutoGenerated && (`to ${feed?.Inquiry?.remarks} ` || "")}
                 
                  {/* {` — ${feed?.description}`} */}
                </Typography>
              </React.Fragment>
              }
            secondary={
              <React.Fragment>
                <Typography
                  sx={{ color: feed?.isAutoGenerated ? "white" : "black", display: "inline" }}
                  component="span"
                  variant="body3"
                  color="text.primary"
                  fontSize={feed?.isAutoGenerated && "12px"}
                  fontFamily={feed?.isAutoGenerated && "Consolas"}
                >
                  {/* {feed?.Employee?.name} */}
                  {feed?.description}
                  {/* {` — ${feed?.description}`} */}
                </Typography>
              </React.Fragment>
            }
              // primary={feed?.Inquiry?.InquiryType?.name || ""}
              // secondary={
              //   <React.Fragment>
              //     <Typography
              //       sx={{ color: feed?.isAutoGenerated ? "white" : "black", display: "inline" }}
              //       component="span"
              //       variant="body2"
              //       color="text.primary"
              //     >
              //       {feed?.Employee?.name}
              //       {` — ${feed?.description}`}
              //     </Typography>
              //   </React.Fragment>
              // }
            />
          </ChatItem>
          {!isAccepted &&
            !isLoading &&
            feed?.isAutoGenerated &&
            !feed?.Inquiry?.isAccepted &&
            (user.id === feed?.Inquiry?.employee || feed?.Inquiry?.department === user?.department
              ||feed?.Inquiry?.department === 1 || user?.role===1) && (
              <IconButton aria-label="delete" size="large" onClick={() => acceptRequest()}>
                <OfflineBoltIcon sx={{ color: "red" }} />
              </IconButton>
            )}
          {isLoading && (
            <IconButton aria-label="delete" size="large">
              <PendingIcon sx={{ color: "green" }} />
            </IconButton>
          )}
        </>
      )}
    </Grid>
  );
};

export default ChatLeft;
